import { getApiHeaders } from 'Compass/profile-lab/services/headers';

declare const WEBSERVER_BASE_URL: string;

export const apiPost = async <T = unknown>(endpoint: string, body: unknown): Promise<T> => {
  const response = await fetch(`${WEBSERVER_BASE_URL}${endpoint}`, {
    method: 'POST',
    headers: getApiHeaders(),
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(`API request failed: ${response.statusText}`);
  }

  return await response.json();
};

export const apiGet = async <T = unknown>(endpoint: string): Promise<T> => {
  const response = await fetch(`${WEBSERVER_BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: getApiHeaders()
  });

  if (!response.ok) {
    throw new Error(`API request failed: ${response.statusText}`);
  }

  return await response.json();
};
